/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { onEscape, onFocusOut } from '../utils/focus.js';
/**
 * Given a closable component provides the following
 * - close on escape
 * - close on focusout
 * - close on custom event
 */
export function closable(config = {}) {
    return (target) => {
        target.addInitializer((instance) => {
            if (!instance.closableController) {
                instance.closableController = new ClosableController(instance, config);
            }
        });
    };
}
export class ClosableController {
    constructor(host, config = {}) {
        this.host = host;
        this.config = { escape: true, focusout: false, ...config };
        this.host.addController(this);
    }
    hostConnected() {
        if (this.config.escape) {
            onEscape(this.host, () => this.close('escape-keypress'));
        }
        if (this.config.focusout) {
            this.host.tabIndex = 0; // for a11y focus out https://stackoverflow.com/questions/152975/how-do-i-detect-a-click-outside-an-element
            onFocusOut(this.host, () => this.close('focusout'));
        }
    }
    close(detail) {
        this.host.dispatchEvent(new CustomEvent('closeChange', { detail }));
    }
}
